import { render, staticRenderFns } from "./ExpertPurchaseDetails.vue?vue&type=template&id=6c610cac&scoped=true&"
import script from "./ExpertPurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./ExpertPurchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpertPurchaseDetails.vue?vue&type=style&index=0&id=6c610cac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c610cac",
  null
  
)

export default component.exports